import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { JPInputSearchProps } from "./JPInputSearch.model";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import { JPInputElement } from "@companion-core/shared/app/Components/Inputs/JPInput/JPInputElement";

import "@companion-core/web/src/Assets/Styles/scss/inputSearch.scss";

export const JPInputSearch = ({
  value,
  testID,
  className,
  onValueChange,
  onSubmit,
  onBlur,
  onFocus,
}: JPInputSearchProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    setInputValue(value ?? "");
  }, [value]);

  return (
    <div className={`input-search${className ? ` ${className}` : ""}`}>
      <JPInputElement
        name="input-search"
        testID={`input-search-${testID}`}
        className="input-search__input"
        type="text"
        value={inputValue}
        placeholder={t("common.dynamic-content.filters.search.placeholder")}
        prefix={isFocused ? <FontIcon name="JP-Search" size={24} /> : undefined}
        suffix={isFocused || inputValue ? undefined : <FontIcon name="JP-Search" size={24} />}
        onChange={(
          e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
        ) => {
          setInputValue(e.target.value);
          onValueChange?.(e.target.value);
        }}
        onSubmit={() => onSubmit?.(inputValue)}
        onReset={() => {
          onSubmit?.("");
          setInputValue("");
        }}
        onBlur={() => {
          onBlur?.();
          setIsFocused(false);
        }}
        onFocus={() => {
          onFocus?.();
          setIsFocused(true);
        }}
      />
    </div>
  );
};
